module.exports = __webpack_public_path__ + "img/novelty-info.2730b612.png";